import React, { useState } from 'react';
import { DialogTitle } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { makeApplication } from '../AttachChildDucks';
import { useDispatch } from 'react-redux';
import UploadFilesComponent from './UploadFilesComponent';
import DescriptionList from './DescriptionList';
import { useForm } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import UserInputFields from './UserInputFields';
import Button from '../../../modules/Button/Button';
import Modal from '../../../_ui/Modal/Modal';

export default function AttachChildDialog({
  open,
  onClose,
  filter,
  loading,
  requesterIin
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const form = useForm({
    mode: 'all',
    shouldUnregister: false
  });
  const [childIinError, setChildIinError] = useState('');
  const [fileError, setFileError] = useState('');
  const [parentStatusError, setParentStatusError] = useState('');

  const { control, setValue, handleSubmit } = form;

  const onSubmit = data => {
    let hasError = false;

    if (!data.childIin) {
      setChildIinError(t('attachChild_noIin'));
      hasError = true;
    } else if (!/^\d{12}$/.test(data.childIin)) {
      setChildIinError(t('attachChild_badInputIin'));
      hasError = true;
    } else {
      setChildIinError('');
    }

    if (!data.files || data.files.length === 0) {
      setFileError(t('attachChild_noFile'));
      hasError = true;
    } else {
      setFileError('');
    }

    if (!data.parentStatus) {
      setParentStatusError(t('attachChild_noParentStatus'));
      hasError = true;
    }

    if (hasError) return;

    dispatch(makeApplication(data.childIin, requesterIin, { ...data }, onClose, filter));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">{t('attachChild_attachChild')}</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Grid container>
            <UserInputFields
              childIinError={childIinError}
              setChildIinError={setChildIinError}
              parentStatusError={parentStatusError}
              setParentStatusError={setParentStatusError}
              control={control}
            />
            <DescriptionList />
            <UploadFilesComponent
              setValue={setValue}
              control={control}
              fileError={fileError}
              setFileError={setFileError}
            />
          </Grid>
        </DialogContent>
        <DialogActions style={{ textAlign: 'center' }}>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            loading={loading}
            text={t('attachChildModal_apply')}
          />
        </DialogActions>
      </form>
    </Modal>
  );
}
